import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, patch, removeItem } from '@ngxs/store/operators';
import { TenantConfiguration } from '../../../core/domain/models/tenant-configuration-model';
import { LoaderHandler } from '../../../core/domain/models';
import {
  DisableLoading,
  EnableLoading,
  SetIsCreated,
  SetIsDeleted,
  SetIsUpdated,
  SetTotalRecords,
  SetTenantConfigurations,

} from './base.actions';

export class BaseStateModel {
  totalRecords: number | undefined;
  isCreated: boolean | undefined;
  isUpdated: boolean | undefined;
  isDeleted: boolean | undefined;
  tenantConfiguration:TenantConfiguration[]|undefined;
  loading: LoaderHandler[] | undefined;
}

const defaults = {
  totalRecords: undefined,
  loading: undefined,
  isCreated: undefined,
  isUpdated: undefined,
  tenantConfiguration:undefined,
  isDeleted: undefined,
};

@State<BaseStateModel>({
  name: 'mls_base',
  defaults,
})
@Injectable({ providedIn: 'root' })
export class BaseState {
  @Selector()
  static totalRecords(state: BaseStateModel) {
    return state.totalRecords;
  }

  @Selector()
  static loading(state: BaseStateModel) {
    return state.loading;
  }
  @Selector()
static tenantConfigurations(state: BaseStateModel) {
  return state.tenantConfiguration;
}
  @Selector()
  static isCreated(state: BaseStateModel) {
    return state.isCreated;
  }

  @Selector()
  static isUpdated(state: BaseStateModel) {
    return state.isUpdated;
  }

  @Selector()
  static isDeleted(state: BaseStateModel) {
    return state.isDeleted;
  }

  @Action(SetTotalRecords)
  setTotalRecords(
    ctx: StateContext<BaseStateModel>,
    { payload }: SetTotalRecords
  ) {
    ctx.setState({ ...ctx.getState(), totalRecords: payload });
  }

  @Action(EnableLoading)
  enableLoading(ctx: StateContext<BaseStateModel>, { payload }: EnableLoading) {
    if (payload)
      ctx.setState(patch({ ...ctx.getState(), loading: append([payload]) }));
  }
  @Action(SetTenantConfigurations)
 setConfigurations(ctx: StateContext<BaseStateModel>, { payload }: SetTenantConfigurations) {
   ctx.setState({ ...ctx.getState(), tenantConfiguration: payload });
 }
  @Action(DisableLoading)
  disableLoading(
    ctx: StateContext<BaseStateModel>,
    { payload }: DisableLoading
  ) {
    ctx.setState(
      patch({
        ...ctx.getState(),
        loading: removeItem<LoaderHandler>(
          (x) =>
            x?.endPointName === payload?.endPointName &&
            x?.componentName === payload?.componentName
        ),
      })
    );
  }

  @Action(SetIsCreated)
  setIsCreated(ctx: StateContext<BaseStateModel>, { payload }: SetIsCreated) {
    ctx.setState({ ...ctx.getState(), isCreated: payload });
  }

  @Action(SetIsUpdated)
  setIsUpdated(ctx: StateContext<BaseStateModel>, { payload }: SetIsCreated) {
    ctx.setState({ ...ctx.getState(), isUpdated: payload });
  }

  @Action(SetIsDeleted)
  setIsDeleted(ctx: StateContext<BaseStateModel>, { payload }: SetIsCreated) {
    ctx.setState({ ...ctx.getState(), isDeleted: payload });
  }
}
